import React from "react";
import LockSVG from "../../assets/permissions_admin.svg";
import styles from "./LockIcon.module.css";

/**
 * View component. An icon that displays when voting is locked on a decision item.
 */
export function LockIcon() {
  return (
    <div className={styles["inline-flex"]}>
      <img
        src={LockSVG}
        className={styles.svg}
        alt="Voting is locked on decision item"
      />
    </div>
  );
}
